import type { Dispatch, SetStateAction } from 'react';
import type { Option } from '@/components/inputs/AutocompleteInput';
import type { RoutesFilter } from '../models';
import { optionDataHasStringId } from './optionDataHasStringId';

type IdFieldKey = 'logisticOperatorId';

export function applyRoutesFilterAutocompleteIdField(
  option: Option | null,
  setLocalFilter: Dispatch<SetStateAction<RoutesFilter>>,
  fieldKey: IdFieldKey
): void {
  const data = option?.data;
  if (!optionDataHasStringId(data)) {
    setLocalFilter((previous) => ({ ...previous, [fieldKey]: undefined }));
    return;
  }
  const trimmedSelectedId = data.id.trim();
  if (!trimmedSelectedId) {
    setLocalFilter((previous) => ({ ...previous, [fieldKey]: undefined }));
    return;
  }
  setLocalFilter((previous) => ({
    ...previous,
    [fieldKey]: trimmedSelectedId,
  }));
}
